module.exports = __webpack_public_path__ + "static/media/fusion-ginssen-icon-02.d94412ab.png";